import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { ToastrService } from 'ngx-toastr';
import { USER_MGMT_CNST } from '../constants/proj.cnst';
import { Config } from '../enums';
import { InitService } from '../parsers/init.service';
import { KeycloakService } from 'keycloak-angular';
import { Router } from '@angular/router';
import { AppStateService } from '../services/app-state.service';
import { AuthenticationService } from '../modules/authentication/services/authentication.service';
import { EnvService } from './env.service';
import { isNullOrUndefined } from '../modules/shared/common-utils';
/**
 * NOTE: .
 * Use this service to write some common formatters which can be shared across projects..
 * Don't write chart/table formatters here.
 *
 * EXAMPLE:
 *  - Generating a UUID.
 *  - Date Utils
 *  etc..
 */
@Injectable({
  providedIn: 'root'
})
export class UtilsService {

  constructor(
    private httpSrv: HttpService,
    private toastr: ToastrService,
    private intitSrv: InitService,
    private keyCloakSrv: KeycloakService,
    private appStateSrv: AppStateService,
    private authSrv: AuthenticationService,
    private envService : EnvService,
    private router: Router
  ) { }

  async checkUser(userId: string): Promise<boolean> {
    let promise: Promise<boolean> = new Promise((resolve) => {

      if (!userId) resolve(false);

      this.httpSrv
        .makePostApiCall('CHECK_IF_DANA_USER', { userId }, this.envService.baseUrl)
        .subscribe(() => {
          resolve(true);
        }, err => {
          this.showToastMessage(err, 'error');

          // if (USER_MGMT_CNST.ACCESS_TYPE === USER_MGMT_CNST.ACCESS_TYPE_LIST.PROD) {
          //   this.oauthSrv.logOut();
          // }

          resolve(false);
        })
    })
    return promise;
  }

  showToastMessage(message: string, type: string, options?: any): void {
    let toastOptions: any = USER_MGMT_CNST.TOASTR_CNST;
    if (!isNullOrUndefined(options)) {
      toastOptions = { ...USER_MGMT_CNST.TOASTR_CNST, ...options.options };
    }
    this.toastr.clear();
    (this.toastr[type as keyof typeof this.toastr] as any)(message, toastOptions.title, toastOptions);
  }


  handleSuccess(res: any) {
    let config = this.intitSrv.getConfig(Config.FORGOT_PASSWD_CONFIG)
    let message = res.message ? res.message : config.toasterMessages.otp.success;
    this.showToastMessage(message, 'success');
    return true
  }

  makeOtpSendApiCall(api: any, postParams: any) {
    return new Promise((resolve, reject) => {
      this.httpSrv.makePostApiCall(api, postParams, this.envService.baseUrl)
        .subscribe(res => {
          if (res.result) {
            return resolve(this.handleSuccess(res))
          }
          else {
            return resolve(false)
          }
        }
          , error => {
            return resolve(false);
          })
    })
  }

  handleValidateSuccess(res: any) {
    let config = this.intitSrv.getConfig(Config.FORGOT_PASSWD_CONFIG)
    let message = res.message ? res.message : config.toasterMessages.changePassword.success;
    this.showToastMessage(message, 'success');
    return true
  }

  makeOtpValidateApiCall(api: any, postParams: any) {
    return new Promise((resolve, reject) => {
      this.httpSrv.makePostApiCall(api, postParams, this.envService.baseUrl).subscribe(res => {
          if (res.result) {
            return resolve(this.handleValidateSuccess(res))
          }else {
            return resolve(false)
          }
        }, error => {
          return resolve(false);
        })
    })
  }

  formatViewUsersData(data: any) {
    let sorted: any[] = [];

    if (data && data['viewUser']) {
      //* order of each attribute of user
      let listOrder = USER_MGMT_CNST.ORDER_FOR_VIEW_USERS;
      //* add order and key to each object
      Object.keys(listOrder).forEach(item => {

        data['viewUser'][item]['order'] = listOrder[item as keyof typeof listOrder];
        data['viewUser'][item]['key'] = item;
        //* change class for status alone
        if (item === 'status') {
          data['viewUser'][item]['class'] = 'col-12 mb-3';
        }

      })
      //* convert object into array of objects
      const arrayOfObj = Object.entries(data['viewUser']).map((e) => (e[1]));
      //* sort array based on order
      sorted = arrayOfObj.sort((a: any, b: any) => {
        return (a['order'] - b['order']);
      })

    }

    //* return formatted data

    return sorted;

  }

  setUserPermissionsInLocalStorage(userPermissions: any, userMetaInfo : any) {
    if (this.envService.headerAppName === 'KredosAI') {

      let permissionInLocalStorage = localStorage.getItem('userPermissions');
      let metaInfoInLocalStorage = localStorage.getItem('metaInfo');

      if (this.isObjectNotNullAndEmpty(userPermissions) && isNullOrUndefined(permissionInLocalStorage)) {
        localStorage.setItem('userPermissions', JSON.stringify(userPermissions));
      }

      if (this.isObjectNotNullAndEmpty(userMetaInfo) && isNullOrUndefined(metaInfoInLocalStorage)) {
        localStorage.setItem('metaInfo', JSON.stringify(userMetaInfo));
      }
    }
  }

  async logout(redirect?:boolean) {
    if(await this.keyCloakSrv.isLoggedIn()) {
      await this.keyCloakSrv.logout(this.envService.keyCloakUrls.logoutUrl);
    }else {
      await this.keyCloakSrv.clearToken();
    }
    this.authSrv.setUserInfo(null, (null as any));
    this.appStateSrv.setIsPredefinedResource(false);

    localStorage.clear();
    sessionStorage.clear();

    this.appStateSrv.setPermissionsLoaded(false);
    this.appStateSrv.setInProcess(false);
    this.appStateSrv.setUserMetaInfo({});
    this.appStateSrv.setUserPermissionsRef({});
    if(!redirect) {
    this.router.navigate(USER_MGMT_CNST.COMMON_ROUTE_MAPPING.LOGIN);
    }
  }

  isEmailValid(emailPattern: any, inputStr: string): boolean {
    if (!isNullOrUndefined(inputStr)) {
      return emailPattern.test(inputStr) && (!/\.\.|\.@|@\.|^\./.test(inputStr)) ? true : false;
    } else {
      return false;
    }
  }

  isObjectNotNullAndEmpty(inputObj : any) : boolean {
    return !isNullOrUndefined(inputObj) && Object.keys(inputObj).length > 0;
  }

  buildMobileNumberWithCountryCode(countryCode: string, mobileNo : string) {
    if (!isNullOrUndefined(countryCode) && !isNullOrUndefined(mobileNo)) {
      return `${countryCode}-${mobileNo}`;
    }
    return null
  }

  splitByDelimiter(value : string, delimiter : string) {
    if (!isNullOrUndefined(value)) {
      return value.split(delimiter);
    }
    return null
  }

}
